<template>
	<div class="page-content">
		<el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage">监控产品</span></el-breadcrumb-item>
      <el-breadcrumb-item>监控计划列表</el-breadcrumb-item>
    </el-breadcrumb>
		<div class="activity-search">
      <el-row :gutter="10" type="flex" justify="space-between">
				<el-col :span="8">
          <span class="g-search-gap">计划名称</span>
          <el-input size="small" clearable v-model="search.planname" placeholder="请输入" class="input-width"></el-input>
        </el-col>
        <el-col :span="8" class="position-right">
          <span class="g-search-gap">监控平台</span>
					<el-select size="small" multiple v-model="search.platforms" placeholder="全部" class="input-width">
            <el-option
              v-for="item in platformList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-col>
				<el-col :span="8" class="position-right"  v-if="!isMore">
          <span class="g-search-gap">产品型号</span>
          <el-cascader
						size="small"
						class="g-margin-left"
						v-model="search.product_id"
						filterable
						clearable
						:filter-method="handleFilterMethod"
						:options="getShopProducts"
						:props="cascaderProps">
					</el-cascader>
        </el-col>
				<el-col :span="8" class="position-right" v-if="isMore">
					<span class="more-text" @click="isMore = !isMore">{{isMore ? '点击展开更多' : '收起'}}</span>
          <el-button size="small" plain @click="load(true)">查  询</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="position-top" v-if="!isMore">
        <!-- <el-col :span="8">
          <span class="g-search-gap">通知微信</span>
					<el-select size="small" multiple v-model="search.noticeuserids" placeholder="全部" class="input-width">
            <el-option
              v-for="item in wecharList"
              :key="item.openid"
              :value="item.openid"
              :label="item.nickname"
            >
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="24" class="position-right">
					<span class="more-text" @click="isMore = !isMore">{{isMore ? '点击展开更多' : '收起'}}</span>
          <el-button size="small" plain @click="load(true)">查  询</el-button>
        </el-col>
      </el-row>
    </div>
		<div class="tabs">
			<el-row type="flex" justify="space-between">
				<div>
					<el-button type="primary" size="small" @click="onPushAddPlan">
						<i class="el-icon-plus"></i><span>新增计划</span>
					</el-button>
					<el-button type="plain" size="small" @click="handleSelect">
						<span>批量删除</span>
					</el-button>
					<el-button type="plain" size="small" @click="pushVisible = true">
						<span>设置推送方式</span>
					</el-button>
					<span class="g-margin-left" style="color: red" slot="title">监控产品上限: {{ currentProNum }} / {{ allLimitProNum }}</span>
				</div>
				<el-button size="small" plain @click="download">下载数据</el-button>
			</el-row>
			<div class="notice-wrap" style="margin-top: 5px">
        <i class="el-icon-warning" style="display:inline-block;margin-right:5px;"></i>
        共<span>{{ totalPage }}</span>项
        已选择<span>{{ selectLength }}</span>项
        <span @click="select(1)">勾选全部</span><span>/</span>
        <span @click="select(0)">取消全部</span>
      </div>
			<el-table
				@selection-change="handleSelectionChange"
				style="margin-top: 5px"
				:data="monitorPlanList"
				ref="table">
				<el-table-column
          type="selection"
          width="55">
        </el-table-column>
				<el-table-column
					label="序号"
					type="index"
					width="50">
				</el-table-column>
				<el-table-column
					label="计划名称"
					width="400">
					<template slot-scope="scope">
						<span @click="onOpenDetailDrawer(scope.row)" style="cursor: pointer;color: #108cee;">{{ scope.row.planname }}</span>
					</template>
				</el-table-column>
				<el-table-column
					label="监控平台">
					<template slot-scope="scope">
						<div class="plat-item" v-for="(plat, index) in generatorPlatArr(scope.row.platform)" :key="index">{{ plat }}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="产品型号"
					width="150">
					<template  slot-scope="scope">
						<el-popover
							placement="bottom"
							width="300"
							trigger="hover">
							<div>
								<span v-for="(text, i) in scope.row.product" :key="i" class="g-block">
									{{ text }}
								</span>
							</div>
							<span slot="reference">{{ scope.row.product.length }}个</span>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
					width="180"
					label="监控时间">
					<template slot-scope="scope">
						<span >{{ scope.row.plathour }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column
					label="监控总链接">
					<template slot-scope="scope">
						<span>{{ scope.row.skuDetailList.length }}条</span>
					</template>
				</el-table-column>
				<el-table-column
					label="违规链接">
					<template slot-scope="scope">
						<span>{{ scope.row.islowpriceList.length }}条</span>
					</template>
				</el-table-column>
				<el-table-column
					width="200"
					label="最近监控时间">
					<template slot-scope="scope">
						<span v-if="scope.row.endtime">{{ scope.row.endtime|fullTime }}</span>
						<span v-else>--</span>
					</template>
				</el-table-column> -->
				<!-- <el-table-column
					label="通知微信"
					width="150">
					<template slot-scope="scope">
						<span v-for="(text, i) in scope.row.noticeusername.split(',')" :key="i" class="g-block">
							{{ text }}
						</span>
					</template>
				</el-table-column> -->
				<el-table-column
					width="180"
					label="监控状态">
					<template slot-scope="scope">
						<el-switch
							:value="scope.row.status === 1 ? true : false"
							@change="(val) => onStatusChange(val, scope.row.id)"
							active-color="#408ae7"
							inactive-color="#d9d9d9"
							active-text="开"
							inactive-text="关">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column
					width="210"
					label="操作">
					<template slot-scope="scope">
						<div class="g-inline-block" style="color: #108cee;cursor: pointer;" @click="onPushEditPlan(scope.row.id)">
							<i class="el-icon-edit-outline"></i>
							<span class="g-inline-block">编辑</span>
						</div>
						<div class="g-margin-left" style="color: #108cee;cursor: pointer;" @click="onOpenDeleteDia(scope.row.id)">
							<i class="el-icon-delete"></i>
							<span class="g-inline-block">删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<Pagination
        v-if="totalPage > 0"
        class="pagination"
        :total="totalPage"
        v-model="pagination"
        @onChange='load'
      />
		</div>
		<ComfirmDialog
			:visible="deleteVisible"
			@on-close="deleteVisible = false"
			@on-comfirm="onDeletePlan"
			width="350px"
		>
			<div slot="content" class="g-center">
				<i style="color: #efb141; font-size: 35px" class="el-icon-warning"></i>
				<span class="g-margin-left">
					你确认要删除计划吗？ <br />
					删除后计划数据会被 <span style="color: red">彻底删除</span>
				</span>
			</div>
		</ComfirmDialog>
		<ComfirmDialog
			:visible="pushVisible"
			@on-close="pushVisible = false"
			@on-comfirm="onSetPushWay"
		>
			<div slot="content" class="g-column-center">
				<el-radio class="g-block" v-model="pushWay" :label="0">每个计划每次完成时推送监控结果</el-radio>
				<el-radio style="margin: 30px 30px 0 0;" class="g-block" v-model="pushWay" :label="1">每日计划全部完成时推送监控结果</el-radio>
			</div>
		</ComfirmDialog>
		<MonitorPlanDrawer
			:modalInfo="modalInfoDetail"
			ref="MonitorPlanDrawer"
		/>
	</div>
</template>

<script>
import MonitorPlanDrawer from './components/monitorPlanDrawer'
import ComfirmDialog from 'components/comfirmDialog/comfirmDialog'
import Pagination from 'components/pagination/pagination'
import { mapGetters, mapActions, mapState } from 'vuex';
import { getNoHourTodayOneMonth } from '@/libs/date';
import { handleProductUrl } from '@/libs'
import Shopname from 'components/shopname/Shopname'
export default {
	name: 'ComplaintDataSummary',

	components:{
		Pagination,
		ComfirmDialog,
		MonitorPlanDrawer
	},

	data () {
		return {
			currentProNum: 0,
			allLimitProNum: 0,
			modalInfoDetail: {},
			selcetPlan: {},
			selectLength: 0,
			selectRows: [],
			cascaderProps: {
        value: 'id',
        label: 'productClassifyName'
      },
			platformList: [
				{ value: 'PDD', label: '拼多多' },
				{ value: 'TB', label: '淘宝' },
				{ value: 'TM', label: '天猫' },
				{ value: 'JD', label: '京东' },
				{ value: 'SN', label: '苏宁' },
			],
			deleteVisible: false,
			pushWay: '',
			pushVisible: false,
			isMore: true,
			ids: '',
			pagination: {
        size: 10,
        current: 1
      },
			search: {
				platform: null
			},
			totalPage: 0
		}
	},

	methods: {
		onOpenDetailDrawer(row) {
			this.modalInfoDetail = {
				id:row.id,
				planname:row.planname
			};

			this.$refs.MonitorPlanDrawer.visibleShow = true;
			// console.log(this.selcetPlan);

		},
		handleSelect() {
			if(this.selectLength === this.totalPage) {
				this.ids = 'checkAll'
			}else {
				let ids = [];
				for(let i of this.selectRows) {
          ids.push(i.id)
				}
				this.ids = ids.join(',')
			}
			if(this.ids) {
				this.deleteVisible = true;
			}else {
				this.$message.error('没有选中项');
			}
			console.log(this.ids);
		},
		handleSelectionChange(val) {
      this.selectLength = val.length;
      this.selectRows = val;
    },
		onDeletePlan() {
			fetch({
				method: 'POST',
				url: 'hcm/hcmNewMonitorProduct/delete',
				data: {
					ids: this.ids,
				}
			}).then(res => {
				if(res.status === '10000') {
					this.$message.success('删除计划成功');
					this.deleteVisible = false;
					this.load();
				}
			})
		},
		onOpenDeleteDia(id) {
			this.ids = id;
			this.deleteVisible = true;
		},
		onStatusChange(val, id) {
			fetch({
				method: 'POST',
				url: 'hcm/hcmNewMonitorProduct/updateStatus',
				data: {
					id,
					status: val ? 1 : 0
				}
			}).then(res => {
				if(res.status === '10000') {
					this.$message.success('修改状态成功');
					this.load();
				}
			})
		},
		generatorPlatArr(platform) {
			if(this.monitorPlanList.length) {
				let platforms = platform.split(',');
				return platforms.reduce((res, cur) => {
					let item = this.platformList.find(p => p.value === cur);
					res.push(item.label);
					return res;
				}, [])
			}else {
				return []
			}
		},
		onSetPushWay() {
			fetch({
				method: 'POST',
				url: 'hcm/hcmNewMonitorProduct/updatePushmode',
				data: {
					pushmode: this.pushWay
				}
			}).then(res => {
				console.log(res);
				if(res.status === '10000') {
					this.$message.success('设置成功');
					this.pushVisible = false;
				}
			})
		},
		handleFilterMethod(node, keyword) {
      return node.text.toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
    },
		onPushEditPlan(id) {
			this.$router.push(`/addMonitorPlan/${id}`);
		},
		onPushAddPlan() {
			this.$router.push('/addMonitorPlan/0');
		},
		onChangePage() {
			this.$router.push('/ProductPandect');
		},
		select(type) {
			console.log(this);
			if(type === 1) {
        this.selectRows = this.monitorPlanList;
        for(let r of this.monitorPlanList) {
          this.$refs['table'].toggleRowSelection(r, true)
        }
        this.selectLength = this.totalPage;
      }else {
        this.$refs['table'].clearSelection();
        this.selectRows = [];
        this.selectLength = 0;
      }
    },
		download() {
			let url = `hcm/hcmNewMonitorProduct/download`
      let params = {
        noticeuserids: Array.isArray(this.search.noticeuserids) ? this.search.noticeuserids.join(',') : '',
				planname: this.search.planname,
				platforms: Array.isArray(this.search.platforms) ? this.search.platforms.join(',') : '',
				productid: Array.isArray(this.search.product_id) ? this.search.product_id[1].split(',')[0] : ''
      }
      for(let i in params) {
        if(!params[i]) {
          delete params[i];
        }else {
          url = url + '&' + i + '=' + params[i]
        }
			}
      window.open(url)
		},
		onOpenWindow(url) {
			window.open(url)
		},
		load(isSearch) {
			this.pagination.current = isSearch ? 1 : this.pagination.current;
			console.log(this.search);

			let params = {
				pageNo: this.pagination.current,
				pageSize: this.pagination.size,
				planname: this.search.planname,
				noticeuserids: Array.isArray(this.search.noticeuserids) ? this.search.noticeuserids.join(',') : '',
				productid: Array.isArray(this.search.product_id) ? this.search.product_id.length ? this.search.product_id[1].split(',')[0] : '' : '',
				platforms: Array.isArray(this.search.platforms) ? this.search.platforms.join(',') : ''
			}

			for(let i in params) {
        if(!params[i]) {
          delete params[i];
        }
			}
			this.reqMonitorPlanList(params).then(res => {
				this.totalPage = res.totalElements;
				this.pushWay = Number(res.obj);
			})
		},
		loadMaxProduct() {
			fetch({
			url: 'hcm/cus/selectbmcSetting'
		}).then(res => {
			if(res.status === '10000') {
				this.allLimitProNum = res.data.productmonitorNumber;
			}
		})
		},
		loadProductLimit() {
			fetch({
				method: 'GET',
				url: 'hcm/hcmNewMonitorProduct/getProductCount'
			}).then(res => {
				if(res.status === '10000') {
					this.currentProNum = res.data;
				}
			})
		},
		...mapActions([
			'reqPlateList',
			'reqMonitorPlanList',
			'reqActivityShopProduct'
    ]),
	},

	computed: {
		...mapState({
			monitorPlanList: state => state.monitorPlan.monitorPlanList
		}),
		...mapGetters([
			"plateList",
			"getShopProducts"
    ]),
	},

	created() {
		this.reqActivityShopProduct();
		this.load();
		this.loadProductLimit();
		this.loadMaxProduct();
	},

	mounted() {},
}
</script>


<style lang='scss'>
$highColor: #108cee;
.el-radio__input.is-checked+.el-radio__label {
	color: #bda571;
}

.el-radio__input.is-checked .el-radio__inner {
	border-color: #bda571;
  background: #bda571;
}

.more-text {
  cursor: pointer;
  padding: 0 20px;
  color: $highColor;
}

.plat-item {
	display: inline-block;
	margin-left: 5px;
	border: 1px solid rgb(164, 163, 163);
	padding: 2px;
  border-radius: 4px;
}

.out-notification-img {
	width: 80px;
	height: 80px;
}

.shopInfo {
	padding: 10px;
}

.two_ellipsis{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 2em;
  max-height: 50px;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

@import "style/activityDeclaration.scss";
@import "style/activityApproval.scss";
@import "style/activityApprovalSetting.scss";
</style>
